var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex cursor--pointer",class:`color--${_vm.color}`,on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('em',{staticClass:"mt-1 mr-1",class:_vm.icon}):_vm._e(),_c('span',{class:[`border--${_vm.color}`, { 'border-bottom': _vm.withBorder }]},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }